import type { Component } from 'svelte'
import type { ClassValue, SvelteHTMLElements } from 'svelte/elements'

/**
 * Properties that a compatible inline SVG icon graphic must accept and forward to its root SVG.
 * The graphic owns its children, intrinsic viewBox, and SVG namespace.
 */
export type IconGraphicProps = Omit<
    SvelteHTMLElements['svg'],
    'children' | 'class' | 'viewBox' | 'xmlns'
> & {
    class?: ClassValue
}

/** A Svelte component that renders one compatible inline SVG icon graphic. */
export type IconGraphic = Component<IconGraphicProps>

/**
 * Teaching Strategies design-kit iconography foundations.
 *
 * Figma source:
 * - Catalog: https://www.figma.com/design/Q1oochZOrHxQUlYIamPDNW/%F0%9F%8E%A8-Design-Kit?node-id=462-6726&m=dev
 * - Sizes: https://www.figma.com/design/Q1oochZOrHxQUlYIamPDNW/%F0%9F%8E%A8-Design-Kit?node-id=4402-474540&m=dev
 */
export const DesignKitIconSizes = {
    s: 12,
    m: 16,
    ml: 24,
    l: 32,
    '2l': 48
} as const

export type DesignKitIconSize = keyof typeof DesignKitIconSizes
